var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('loader'),(_vm.loaded)?[_c('router-view'),(_vm.showAppHomeScreenModal)?_c('home-screen-warning-modal',{on:{"close":function($event){_vm.showAppHomeScreenModal = false}}}):_vm._e()]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }